
import { defineComponent } from 'vue'
import { getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'LogoutMenu',

  props: {
    email: {
      type: String,
      required: true
    },
    avatar: {
      type: String,
      default: ''
    },
    fullName: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getDefaultAvatar
  }
})
